import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import { selectCountryList } from '../../../redux/data/selectors';

import { appointmentProgressActions } from '../../../redux/appointmentForm/progress-types';
import * as reasonVisit from '../../../redux/appointmentForm/requests/reason-visit-req';
import {
  selectInspectorRequiredSteps,
  selectProgramBasedVisitId,
  selectProgressCareUser,
  selectProgressOrganizationId,
  selectProgressReason,
  selectProgressService,
  selectProgressServicesByVisit,
  selectReasonVisitList,
  selectReasonVisitPending,
  selectProgressIsUrgentVisitFlow,
  selectProgressVisitTypeCode,
  selectProgressRescheduleData,
  selectMyProvidersVisitTypes,
  selectProgressCareUserSkipInsurance,
  selectProgressOrganizationTenantSkipInsurance,
  selectProgressOrganization,
} from '../../../redux/appointmentForm/selectors';

import styles from './styles.styl';

const mapStateToProps = state => ({
  service: selectProgressService(state),
  careUser: selectProgressCareUser(state),
  savedReason: selectProgressReason(state),
  visitTypeCode: selectProgressVisitTypeCode(state),
  services: selectProgressServicesByVisit(state),
  allVisitTypes: selectMyProvidersVisitTypes(state),
  requiredSteps: selectInspectorRequiredSteps(state),
  organizationId: selectProgressOrganizationId(state),
  rescheduleData: selectProgressRescheduleData(state),
  organization: selectProgressOrganization(state),
  programBasedVisitId: selectProgramBasedVisitId(state),
  isUrgentVisitFlow: selectProgressIsUrgentVisitFlow(state),
  careUserSkipInsurance: selectProgressCareUserSkipInsurance(state),
  selectedOrganizationTenantSkipInsurance: selectProgressOrganizationTenantSkipInsurance(
    state,
  ),
  countriesList: selectCountryList(state),
  reasonVisit: {
    list: selectReasonVisitList(state),
    loading: selectReasonVisitPending(state),
  },
});

const mapDispatchToProps = {
  reasonVisitReq: reasonVisit.actions.send,
  setReason: appointmentProgressActions.setReason,
  setVisitType: appointmentProgressActions.setVisitType,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(
    ({
      service,
      reasonVisitReq,
      rescheduleData,
      countriesList,
      reasonVisit: reasonVisitInfo = {},
    }) => ({
      loading: reasonVisitInfo.loading,
      reasonVisitList: reasonVisitInfo.list.map(item => ({
        value: item.id,
        label: item.name,
      })),
      fetchReasonVisit: () => reasonVisitReq({ serviceId: service.id }),
      reasonTypesList: (() => {
        if (service && service.reasonTypes) {
          return service.reasonTypes.map(item => ({
            label: item.name,
            value: item.id,
          }));
        }
        if (rescheduleData && rescheduleData.possibleReasonTypes) {
          return rescheduleData.possibleReasonTypes.map(item => ({
            value: item.id,
            label: item.name,
            visitTypeCodes: item.visitTypeCodes,
          }));
        }
        return [];
      })(),
      countries: countriesList.map(country => ({
        label: country.name,
        value: country.name,
      })),
      isRescheduleFlow: !!get(rescheduleData, 'id', null),
      isEnabledInsurance: get(
        service,
        'insuranceEligibilityCheckEnabled',
        false,
      ),
    }),
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentVisitDetails/enhance.js